function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("tspan", {
  x: 30.540001,
  y: -184.38,
  id: "tspan843"
}, "100");

var _ref3 = /*#__PURE__*/React.createElement("tspan", {
  x: 30.540001,
  y: -298.32001,
  id: "tspan847"
}, "200");

var _ref4 = /*#__PURE__*/React.createElement("tspan", {
  x: 86.682495,
  y: 10.22092,
  id: "tspan869"
}, "2019");

var _ref5 = /*#__PURE__*/React.createElement("tspan", {
  x: 363.31454,
  y: 171.16945,
  id: "tspan872"
}, "2020");

var _ref6 = /*#__PURE__*/React.createElement("tspan", {
  x: 645.31454,
  y: 335.16945,
  id: "tspan872"
}, "2021");

var _ref7 = /*#__PURE__*/React.createElement("tspan", {
  id: "tspan872"
}, "2022");

var _ref8 = /*#__PURE__*/React.createElement("tspan", {
  x: 144.14,
  y: 19.380001,
  id: "tspan875"
}, "\u0418\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u0430\u043F\u0438\u0442\u0430\u043B");

var _ref9 = /*#__PURE__*/React.createElement("tspan", {
  x: 119.78524,
  y: -302.1192,
  id: "tspan891"
}, "\u0423\u043C\u043D\u044B\u0439 \u0442\u043E\u0440\u0433\u043E\u0432\u044B\u0439 \u0440\u043E\u0431\u043E\u0442");

var _ref10 = /*#__PURE__*/React.createElement("tspan", {
  x: 120.47124,
  y: -277.30869,
  id: "tspan897"
}, "% \u0415\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u0430\u044F \u0434\u043E\u0445\u043E\u0434\u043D\u043E\u0441\u0442\u044C");

var _ref11 = /*#__PURE__*/React.createElement("tspan", {
  x: 86.787277,
  y: -79.827995
}, "\u042F\u043D\u0432");

var _ref12 = /*#__PURE__*/React.createElement("tspan", {
  x: 86.787277,
  y: -135.11028
}, "2.7%");

var _ref13 = /*#__PURE__*/React.createElement("tspan", {
  x: 113.72849,
  y: -79.827995
}, "\u0424\u0435\u0432");

var _ref14 = /*#__PURE__*/React.createElement("tspan", {
  x: 113.72849,
  y: -149.97092066666667
}, "3.8%");

var _ref15 = /*#__PURE__*/React.createElement("tspan", {
  x: 140.66970299999997,
  y: -79.827995
}, "\u041C\u0430\u0440");

var _ref16 = /*#__PURE__*/React.createElement("tspan", {
  x: 140.66970299999997,
  y: -125.65350866666667
}, "2.0%");

var _ref17 = /*#__PURE__*/React.createElement("tspan", {
  x: 167.61091599999997,
  y: -79.827995
}, "\u0410\u043F\u0440");

var _ref18 = /*#__PURE__*/React.createElement("tspan", {
  x: 167.61091599999997,
  y: -128.35544333333334
}, "2.2%");

var _ref19 = /*#__PURE__*/React.createElement("tspan", {
  x: 194.55212899999998,
  y: -79.827995
}, "\u041C\u0430\u0439");

var _ref20 = /*#__PURE__*/React.createElement("tspan", {
  x: 194.55212899999998,
  y: -152.67285533333333
}, "4.0%");

var _ref21 = /*#__PURE__*/React.createElement("tspan", {
  x: 221.49334199999998,
  y: -79.827995
}, "\u0418\u044E\u043D");

var _ref22 = /*#__PURE__*/React.createElement("tspan", {
  x: 221.49334199999998,
  y: -139.163182
}, "3.0%");

var _ref23 = /*#__PURE__*/React.createElement("tspan", {
  x: 248.43455499999993,
  y: -79.827995
}, "\u0418\u044E\u043B");

var _ref24 = /*#__PURE__*/React.createElement("tspan", {
  x: 248.43455499999993,
  y: -141.86511666666667
}, "3.2%");

var _ref25 = /*#__PURE__*/React.createElement("tspan", {
  x: 275.37576799999994,
  y: -79.827995
}, "\u0410\u0432\u0433");

var _ref26 = /*#__PURE__*/React.createElement("tspan", {
  x: 275.37576799999994,
  y: -129.70641066666667
}, "2.3%");

var _ref27 = /*#__PURE__*/React.createElement("tspan", {
  x: 302.31698099999994,
  y: -79.827995
}, "\u0421\u0435\u043D\u0442");

var _ref28 = /*#__PURE__*/React.createElement("tspan", {
  x: 302.31698099999994,
  y: -166.18252866666666
}, "5.0%");

var _ref29 = /*#__PURE__*/React.createElement("tspan", {
  x: 329.25819399999995,
  y: -79.827995
}, "\u041E\u043A\u0442");

var _ref30 = /*#__PURE__*/React.createElement("tspan", {
  x: 329.25819399999995,
  y: -141.86511666666667
}, "3.2%");

var _ref31 = /*#__PURE__*/React.createElement("tspan", {
  x: 356.19940699999995,
  y: -79.827995
}, "\u041D\u043E\u044F");

var _ref32 = /*#__PURE__*/React.createElement("tspan", {
  x: 356.19940699999995,
  y: -144.56705133333332
}, "3.4%");

var _ref33 = /*#__PURE__*/React.createElement("tspan", {
  x: 383.1406199999999,
  y: -79.827995
}, "\u0414\u0435\u043A");

var _ref34 = /*#__PURE__*/React.createElement("tspan", {
  x: 383.1406199999999,
  y: -149.97092066666667
}, "3.8%");

var _ref35 = /*#__PURE__*/React.createElement("tspan", {
  x: 410.0818329999999,
  y: -79.827995
}, "\u042F\u043D\u0432");

var _ref36 = /*#__PURE__*/React.createElement("tspan", {
  x: 410.0818329999999,
  y: -116.19673733333333
}, "1.3%");

var _ref37 = /*#__PURE__*/React.createElement("tspan", {
  x: 437.0230459999999,
  y: -79.827995
}, "\u0424\u0435\u0432");

var _ref38 = /*#__PURE__*/React.createElement("tspan", {
  x: 437.0230459999999,
  y: -139.163182
}, "3.0%");

var _ref39 = /*#__PURE__*/React.createElement("tspan", {
  x: 463.96425899999986,
  y: -79.827995
}, "\u041C\u0430\u0440");

var _ref40 = /*#__PURE__*/React.createElement("tspan", {
  x: 463.96425899999986,
  y: -117.54770466666668
}, "1.4%");

var _ref41 = /*#__PURE__*/React.createElement("tspan", {
  x: 490.90547199999986,
  y: -79.827995
}, "\u0410\u043F\u0440");

var _ref42 = /*#__PURE__*/React.createElement("tspan", {
  x: 490.90547199999986,
  y: -136.46124733333335
}, "2.8%");

var _ref43 = /*#__PURE__*/React.createElement("tspan", {
  x: 517.8466849999999,
  y: -79.827995
}, "\u041C\u0430\u0439");

var _ref44 = /*#__PURE__*/React.createElement("tspan", {
  x: 517.8466849999999,
  y: -147.26898599999998
}, "3.6%");

var _ref45 = /*#__PURE__*/React.createElement("tspan", {
  x: 544.7878979999998,
  y: -79.827995
}, "\u0418\u044E\u043D");

var _ref46 = /*#__PURE__*/React.createElement("tspan", {
  x: 544.7878979999998,
  y: -159.427692
}, "4.5%");

var _ref47 = /*#__PURE__*/React.createElement("tspan", {
  x: 571.7291109999999,
  y: -79.827995
}, "\u0418\u044E\u043B");

var _ref48 = /*#__PURE__*/React.createElement("tspan", {
  x: 571.7291109999999,
  y: -162.12962666666667
}, "4.7%");

var _ref49 = /*#__PURE__*/React.createElement("tspan", {
  x: 598.6703239999998,
  y: -79.827995
}, "\u0410\u0432\u0433");

var _ref50 = /*#__PURE__*/React.createElement("tspan", {
  x: 598.6703239999998,
  y: -139.163182
}, "3.0%");

var _ref51 = /*#__PURE__*/React.createElement("tspan", {
  x: 625.6115369999999,
  y: -79.827995
}, "\u0421\u0435\u043D\u0442");

var _ref52 = /*#__PURE__*/React.createElement("tspan", {
  x: 625.6115369999999,
  y: 14.986453333333316
}, "-7.3%");

var _ref53 = /*#__PURE__*/React.createElement("tspan", {
  x: 652.5527499999998,
  y: -79.827995
}, "\u041E\u043A\u0442");

var _ref54 = /*#__PURE__*/React.createElement("tspan", {
  x: 652.5527499999998,
  y: -127.00447600000001
}, "2.1%");

var _ref55 = /*#__PURE__*/React.createElement("tspan", {
  x: 679.4939629999998,
  y: -79.827995
}, "\u041D\u043E\u044F");

var _ref56 = /*#__PURE__*/React.createElement("tspan", {
  x: 679.4939629999998,
  y: -125.65350866666667
}, "2.0%");

var _ref57 = /*#__PURE__*/React.createElement("tspan", {
  x: 706.4351759999998,
  y: -79.827995
}, "\u0414\u0435\u043A");

var _ref58 = /*#__PURE__*/React.createElement("tspan", {
  x: 706.4351759999998,
  y: -155.37479000000002
}, "4.2%");

var _ref59 = /*#__PURE__*/React.createElement("tspan", {
  x: 733.3763889999998,
  y: -79.827995
}, "\u042F\u043D\u0432");

var _ref60 = /*#__PURE__*/React.createElement("tspan", {
  x: 733.3763889999998,
  y: -144.56705133333332
}, "3.4%");

var _ref61 = /*#__PURE__*/React.createElement("tspan", {
  x: 760.3176019999997,
  y: -79.827995
}, "\u0424\u0435\u0432");

var _ref62 = /*#__PURE__*/React.createElement("tspan", {
  x: 760.3176019999997,
  y: -139.163182
}, "3.0%");

var _ref63 = /*#__PURE__*/React.createElement("tspan", {
  x: 787.2588149999998,
  y: -79.827995
}, "\u041C\u0430\u0440");

var _ref64 = /*#__PURE__*/React.createElement("tspan", {
  x: 787.2588149999998,
  y: -181.0431693333333
}, "6.1%");

var _ref65 = /*#__PURE__*/React.createElement("tspan", {
  x: 814.2000279999997,
  y: -79.827995
}, "\u0410\u043F\u0440");

var _ref66 = /*#__PURE__*/React.createElement("tspan", {
  x: 814.2000279999997,
  y: -160.77865933333334
}, "4.6%");

var _ref67 = /*#__PURE__*/React.createElement("tspan", {
  x: 841.1412409999997,
  y: -79.827995
}, "\u041C\u0430\u0439");

var _ref68 = /*#__PURE__*/React.createElement("tspan", {
  x: 841.1412409999997,
  y: -143.216084
}, "3.3%");

var _ref69 = /*#__PURE__*/React.createElement("tspan", {
  x: 868.0824539999998,
  y: -79.827995
}, "\u0418\u044E\u043D");

var _ref70 = /*#__PURE__*/React.createElement("tspan", {
  x: 868.0824539999998,
  y: -141.86511666666667
}, "3.2%");

var _ref71 = /*#__PURE__*/React.createElement("tspan", {
  x: 895.0236669999997,
  y: -79.827995
}, "\u0418\u044E\u043B");

var _ref72 = /*#__PURE__*/React.createElement("tspan", {
  x: 895.0236669999997,
  y: -135.11028
}, "2.7%");

var _ref73 = /*#__PURE__*/React.createElement("tspan", {
  x: 921.9648799999998,
  y: -79.827995
}, "\u0410\u0432\u0433");

var _ref74 = /*#__PURE__*/React.createElement("tspan", {
  x: 921.9648799999998,
  y: -106.73996600000001
}, "0.6%");

var _ref75 = /*#__PURE__*/React.createElement("tspan", {
  x: 948.9060929999997,
  y: -79.827995
}, "\u0421\u0435\u043D\u0442");

var _ref76 = /*#__PURE__*/React.createElement("tspan", {
  x: 948.9060929999997,
  y: -154.02382266666666
}, "4.1%");

var _ref77 = /*#__PURE__*/React.createElement("tspan", {
  x: 975.8473059999997,
  y: -79.827995
}, "\u041E\u043A\u0442");

var _ref78 = /*#__PURE__*/React.createElement("tspan", {
  x: 975.8473059999997,
  y: -139.163182
}, "3.0%");

var _ref79 = /*#__PURE__*/React.createElement("tspan", {
  x: 1002.7885189999997,
  y: -79.827995
}, "\u041D\u043E\u044F");

var _ref80 = /*#__PURE__*/React.createElement("tspan", {
  x: 1002.7885189999997,
  y: -164.83156133333335
}, "4.9%");

var _ref81 = /*#__PURE__*/React.createElement("tspan", {
  x: 1029.7297319999996,
  y: -79.827995
}, "\u0414\u0435\u043A");

var _ref82 = /*#__PURE__*/React.createElement("tspan", {
  x: 1029.7297319999996,
  y: -137.81221466666665
}, "2.9%");

var _ref83 = /*#__PURE__*/React.createElement("tspan", {
  x: 1056.6709449999996,
  y: -79.827995
}, "\u042F\u043D\u0432");

var _ref84 = /*#__PURE__*/React.createElement("tspan", {
  x: 1056.6709449999996,
  y: -120.24963933333333
}, "1.6%");

var _ref85 = /*#__PURE__*/React.createElement("tspan", {
  x: 1083.6121579999997,
  y: -79.827995
}, "\u0424\u0435\u0432");

var _ref86 = /*#__PURE__*/React.createElement("tspan", {
  x: 1083.6121579999997,
  y: -166.18252866666666
}, "5.0%");

var _ref87 = /*#__PURE__*/React.createElement("tspan", {
  x: 1110.5533709999995,
  y: -79.827995
}, "\u041C\u0430\u0440");

var _ref88 = /*#__PURE__*/React.createElement("tspan", {
  x: 1110.5533709999995,
  y: -109.44190066666667
}, "0.8%");

var _ref89 = /*#__PURE__*/React.createElement("tspan", {
  x: 795.88745,
  y: -250.29311,
  id: "tspan1126"
}, "\u0418\u043D\u0434\u0435\u043A\u0441 S&P 500");

var _ref90 = /*#__PURE__*/React.createElement("tspan", {
  x: 133.334663,
  y: 1155.06995,
  id: "tspan879"
}, "\u0415\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u0430\u044F \u0434\u043E\u0445\u043E\u0434\u043D\u043E\u0441\u0442\u044C");

function SvgPerfRu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%"
    },
    width: 1537.56261,
    height: 531.33332,
    viewBox: "0 0 1537.56261 531.33332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "historical_001",
    transform: "matrix(1.3333333,0,0,-1.3333333,-12.026668,531.33332)",
    sodipodiInsensitive: "true"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "scale(1,-1)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      writingMode: "lr-tb",
      fill: "#4d4d4d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    x: 30.540001,
    y: -184.38,
    id: "text845"
  }, _ref2), /*#__PURE__*/React.createElement("text", {
    transform: "scale(1,-1)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      writingMode: "lr-tb",
      fill: "#4d4d4d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    x: 30.540001,
    y: -298.32001,
    id: "text849"
  }, _ref3), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.5)",
    id: "g855"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 35.74,187.61 h 2.74",
    style: {
      fill: "none",
      stroke: "#b3b3b3",
      strokeWidth: 0.53,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.74,301.55 h 2.74",
    style: {
      fill: "none",
      stroke: "#b3b3b3",
      strokeWidth: 0.53,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path853"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8660254,0.5,0.5,-0.8660254,0,0)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      writingMode: "lr-tb",
      fill: "#4d4d4d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    x: 86.682495,
    y: 10.22092,
    id: "t2019"
  }, _ref4), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8660254,0.5,0.5,-0.8660254,0,0)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      writingMode: "lr-tb",
      fill: "#4d4d4d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    x: 363.31454,
    y: 171.16945,
    id: "t2020"
  }, _ref5), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8660254,0.5,0.5,-0.8660254,0,0)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      writingMode: "lr-tb",
      fill: "#4d4d4d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    x: 645.31454,
    y: 335.16945,
    id: "t2021"
  }, _ref6), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8660254,0.5,0.5,-0.8660254,0,0)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      writingMode: "lr-tb",
      fill: "#4d4d4d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    x: 915,
    y: 495,
    id: "t2021"
  }, _ref7), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0,1,1,0,0,0)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      writingMode: "lr-tb",
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    x: 144.14,
    y: 19.380001,
    id: "text877"
  }, _ref8), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#f7a91e",
      strokeWidth: 4.24264,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 87.723977,307.10352 H 111.6487",
    id: "path889"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 119.78524,
    y: -302.1192,
    transform: "scale(1,-1)",
    id: "text893"
  }, _ref9), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ebebeb",
      strokeWidth: 11.25,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 87.46995,283.72642 h 23.92472",
    id: "path895"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 120.47124,
    y: -277.30869,
    transform: "scale(1,-1)",
    id: "text899"
  }, _ref10), /*#__PURE__*/React.createElement("path", {
    d: "m 73.983616,187.59654999999998 26.884584,2.7728999999999995",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "jan2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.803401,93.634162 h 24.2231 v 36.476118 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "jan2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 86.787277,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "jan2019l"
  }, _ref11), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 86.787277,
    y: -135.11028,
    transform: "scale(1,-1)",
    id: "jan2019lb"
  }, _ref12), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 259.18447999999995,
    x: 75,
    y: -263.5,
    pointerEvents: "visible",
    id: "jan2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 100.8682,190.29654999999997 26.884584,4.0508988",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "feb2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 102.71340099999999,93.634162 h 24.2231 v 51.33675866666666 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "feb2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 113.72849,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "feb2019l"
  }, _ref13), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 113.72849,
    y: -149.97092066666667,
    transform: "scale(1,-1)",
    id: "feb2019lb"
  }, _ref14), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 259.18447999999995,
    x: 101.95,
    y: -263.5,
    pointerEvents: "visible",
    id: "feb2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 127.75278399999999,194.19914999999997 26.884584,2.1746930399999997",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "mar2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 129.623401,93.634162 h 24.2231 v 27.019346666666664 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "mar2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 140.66970299999997,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "mar2019l"
  }, _ref15), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 140.66970299999997,
    y: -125.65350866666667,
    transform: "scale(1,-1)",
    id: "mar2019lb"
  }, _ref16), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 259.18447999999995,
    x: 128.9,
    y: -263.5,
    pointerEvents: "visible",
    id: "mar2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 154.63736799999998,196.331202 26.884584,2.444789915568",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "apr2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.533401,93.634162 h 24.2231 v 29.721281333333334 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "apr2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 167.61091599999997,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "apr2019l"
  }, _ref17), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 167.61091599999997,
    y: -128.35544333333334,
    transform: "scale(1,-1)",
    id: "apr2019lb"
  }, _ref18), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 259.18447999999995,
    x: 155.85,
    y: -263.5,
    pointerEvents: "visible",
    id: "apr2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 181.521952,198.723364344 26.884584,4.6228754767104",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "may2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 183.443401,93.634162 h 24.2231 v 54.03869333333333 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "may2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 194.55212899999998,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "may2019l"
  }, _ref19), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 194.55212899999998,
    y: -152.67285533333333,
    transform: "scale(1,-1)",
    id: "may2019lb"
  }, _ref20), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 259.18447999999995,
    x: 182.8,
    y: -263.5,
    pointerEvents: "visible",
    id: "may2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 208.40653600000002,203.16843691776 26.884584,3.5711713057587837",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "jun2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 210.35340100000002,93.634162 h 24.2231 v 40.529019999999996 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "jun2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 221.49334199999998,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "jun2019l"
  }, _ref21), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 221.49334199999998,
    y: -139.163182,
    transform: "scale(1,-1)",
    id: "jun2019lb"
  }, _ref22), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 259.18447999999995,
    x: 209.75,
    y: -263.5,
    pointerEvents: "visible",
    id: "jun2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 235.29111999999998,206.6355935252928 26.884584,3.93114537337927",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "jul2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237.263401,93.634162 h 24.2231 v 43.23095466666666 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "jul2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 248.43455499999993,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "jul2019l"
  }, _ref23), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 248.43455499999993,
    y: -141.86511666666667,
    transform: "scale(1,-1)",
    id: "jul2019lb"
  }, _ref24), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 259.18447999999995,
    x: 236.7,
    y: -263.5,
    pointerEvents: "visible",
    id: "jul2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 262.175704,210.44484291810215 26.884584,2.8904974840700253",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "aug2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.173401,93.634162 h 24.2231 v 31.072248666666663 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "aug2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 275.37576799999994,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "aug2019l"
  }, _ref25), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 275.37576799999994,
    y: -129.70641066666667,
    transform: "scale(1,-1)",
    id: "aug2019lb"
  }, _ref26), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 259.18447999999995,
    x: 263.65,
    y: -263.5,
    pointerEvents: "visible",
    id: "aug2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 289.060288,213.2703536552185 26.884584,6.597874691898971",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "sept2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 291.083401,93.634162 h 24.2231 v 67.54836666666665 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "sept2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 302.31698099999994,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "sept2019l"
  }, _ref27), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 302.31698099999994,
    y: -166.18252866666666,
    transform: "scale(1,-1)",
    id: "sept2019lb"
  }, _ref28), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 290.6,
    y: -358.73468,
    pointerEvents: "visible",
    id: "sept2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 315.944872,219.5540438379794 26.884584,4.357764276505432",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "oct2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 317.993401,93.634162 h 24.2231 v 43.23095466666666 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "oct2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 329.25819399999995,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "oct2019l"
  }, _ref29), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 329.25819399999995,
    y: -141.86511666666667,
    transform: "scale(1,-1)",
    id: "oct2019lb"
  }, _ref30), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 317.54999999999995,
    y: -358.73468,
    pointerEvents: "visible",
    id: "oct2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 342.829456,223.77668364079477 26.884584,4.787548778275781",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "nov2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 344.90340100000003,93.634162 h 24.2231 v 45.93288933333333 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "nov2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 356.19940699999995,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "nov2019l"
  }, _ref31), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 356.19940699999995,
    y: -144.56705133333332,
    transform: "scale(1,-1)",
    id: "nov2019lb"
  }, _ref32), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 344.5,
    y: -358.73468,
    pointerEvents: "visible",
    id: "nov2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 369.71404,228.4068081845818 26.884584,5.554119823832645",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "dec2019m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 371.813401,93.634162 h 24.2231 v 51.33675866666666 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "dec2019r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 383.1406199999999,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "dec2019l"
  }, _ref33), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 383.1406199999999,
    y: -149.97092066666667,
    transform: "scale(1,-1)",
    id: "dec2019lb"
  }, _ref34), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 371.45,
    y: -358.73468,
    pointerEvents: "visible",
    id: "dec2019cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 396.598624,233.75759799559592 26.884584,1.9247948410540021",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "jan2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 398.723401,93.634162 h 24.2231 v 17.56257533333333 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "jan2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 410.0818329999999,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "jan2020l"
  }, _ref35), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 410.0818329999999,
    y: -116.19673733333333,
    transform: "scale(1,-1)",
    id: "jan2020lb"
  }, _ref36), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 398.4,
    y: -358.73468,
    pointerEvents: "visible",
    id: "jan2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 423.483208,235.65769161953864 26.884584,4.575089276043744",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "feb2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 425.633401,93.634162 h 24.2231 v 40.529019999999996 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "feb2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 437.0230459999999,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "feb2020l"
  }, _ref37), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 437.0230459999999,
    y: -139.163182,
    transform: "scale(1,-1)",
    id: "feb2020lb"
  }, _ref38), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 425.34999999999997,
    y: -358.73468,
    pointerEvents: "visible",
    id: "feb2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 450.367792,240.09952586812477 26.884584,2.1649322454238997",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "mar2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 452.543401,93.634162 h 24.2231 v 18.913542666666665 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "mar2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 463.96425899999986,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "mar2020l"
  }, _ref39), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 463.96425899999986,
    y: -117.54770466666668,
    transform: "scale(1,-1)",
    id: "mar2020lb"
  }, _ref40), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 452.3,
    y: -358.73468,
    pointerEvents: "visible",
    id: "mar2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 477.25237599999997,242.23456753027853 26.884584,4.451100696591538",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "apr2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 479.453401,93.634162 h 24.2231 v 37.82708533333333 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "apr2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 490.90547199999986,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "apr2020l"
  }, _ref41), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 490.90547199999986,
    y: -136.46124733333335,
    transform: "scale(1,-1)",
    id: "apr2020lb"
  }, _ref42), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 479.25,
    y: -358.73468,
    pointerEvents: "visible",
    id: "apr2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 504.13696,246.56443202112632 26.884584,5.928866127859928",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "may2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 506.363401,93.634162 h 24.2231 v 48.634823999999995 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "may2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 517.8466849999999,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "may2020l"
  }, _ref43), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 517.8466849999999,
    y: -147.26898599999998,
    transform: "scale(1,-1)",
    id: "may2020lb"
  }, _ref44), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 506.2,
    y: -358.73468,
    pointerEvents: "visible",
    id: "may2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 531.0215440000001,252.2872757738869 26.884584,7.74458137951703",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "jun2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 533.273401,93.634162 h 24.2231 v 60.79353 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "jun2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 544.7878979999998,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "jun2020l"
  }, _ref45), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 544.7878979999998,
    y: -159.427692,
    transform: "scale(1,-1)",
    id: "jun2020lb"
  }, _ref46), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 533.15,
    y: -358.73468,
    pointerEvents: "visible",
    id: "jun2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 557.906128,259.6983584337118 26.884584,8.468957891214524",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "jul2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 560.183401,93.634162 h 24.2231 v 63.49546466666666 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "jul2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 571.7291109999999,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "jul2020l"
  }, _ref47), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 571.7291109999999,
    y: -162.12962666666667,
    transform: "scale(1,-1)",
    id: "jul2020lb"
  }, _ref48), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 560.0999999999999,
    y: -358.73468,
    pointerEvents: "visible",
    id: "jul2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 584.790712,267.78714343009625 26.884584,5.567889336989975",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "aug2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 587.093401,93.634162 h 24.2231 v 40.529019999999996 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "aug2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 598.6703239999998,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "aug2020l"
  }, _ref49), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 598.6703239999998,
    y: -139.163182,
    transform: "scale(1,-1)",
    id: "aug2020lb"
  }, _ref50), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 587.05,
    y: -358.73468,
    pointerEvents: "visible",
    id: "aug2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 611.675296,273.1928612329991 26.884584,-12.559487977448287",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "sept2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 614.003401,93.634162 h 24.2231 v -98.62061533333332 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "sept2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 625.6115369999999,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "sept2020l"
  }, _ref51), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 625.6115369999999,
    y: 9.986453333333316,
    transform: "scale(1,-1)",
    id: "sept2020lb"
  }, _ref52), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 614,
    y: -358.73468,
    pointerEvents: "visible",
    id: "sept2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 638.55988,259.6443305129902 26.884584,3.688876461979023",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "oct2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 640.913401,93.634162 h 24.2231 v 28.370314 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "oct2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 652.5527499999998,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "oct2020l"
  }, _ref53), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 652.5527499999998,
    y: -127.00447600000001,
    transform: "scale(1,-1)",
    id: "oct2020lb"
  }, _ref54), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 640.9499999999999,
    y: -358.73468,
    pointerEvents: "visible",
    id: "oct2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 665.444464,263.25733390376297 26.884584,3.583479991636765",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "nov2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 667.823401,93.634162 h 24.2231 v 27.019346666666664 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "nov2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 679.4939629999998,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "nov2020l"
  }, _ref55), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 679.4939629999998,
    y: -125.65350866666667,
    transform: "scale(1,-1)",
    id: "nov2020lb"
  }, _ref56), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 667.9,
    y: -358.73468,
    pointerEvents: "visible",
    id: "nov2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 692.329048,266.7705495818382 26.884584,7.84137091769957",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "dec2020m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 694.733401,93.634162 h 24.2231 v 56.740628 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "dec2020r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 706.4351759999998,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "dec2020l"
  }, _ref57), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 706.4351759999998,
    y: -155.37479000000002,
    transform: "scale(1,-1)",
    id: "dec2020lb"
  }, _ref58), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 694.85,
    y: -358.73468,
    pointerEvents: "visible",
    id: "dec2020cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 719.213632,274.2958575642755 26.884584,6.563600856729669",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "jan2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721.643401,93.634162 h 24.2231 v 45.93288933333333 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "jan2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 733.3763889999998,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "jan2021l"
  }, _ref59), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 733.3763889999998,
    y: -144.56705133333332,
    transform: "scale(1,-1)",
    id: "jan2021lb"
  }, _ref60), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 721.8,
    y: -358.73468,
    pointerEvents: "visible",
    id: "jan2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 746.098216,280.64363402146085 26.884584,5.965154896263141",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "feb2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 748.553401,93.634162 h 24.2231 v 40.529019999999996 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "feb2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 760.3176019999997,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "feb2021l"
  }, _ref61), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 760.3176019999997,
    y: -139.163182,
    transform: "scale(1,-1)",
    id: "feb2021lb"
  }, _ref62), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 748.75,
    y: -358.73468,
    pointerEvents: "visible",
    id: "feb2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 772.9828,286.43504654210466 26.884584,12.869026334701557",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "mar2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 775.463401,93.634162 h 24.2231 v 82.40900733333332 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "mar2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 787.2588149999998,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "mar2021l"
  }, _ref63), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 787.2588149999998,
    y: -181.0431693333333,
    transform: "scale(1,-1)",
    id: "mar2021lb"
  }, _ref64), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 775.6999999999999,
    y: -358.73468,
    pointerEvents: "visible",
    id: "mar2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 799.867384,298.56419483117304 26.884584,10.150919198696723",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "apr2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 802.3734010000001,93.634162 h 24.2231 v 62.14449733333333 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "apr2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 814.2000279999997,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "apr2021l"
  }, _ref65), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 814.2000279999997,
    y: -160.77865933333334,
    transform: "scale(1,-1)",
    id: "apr2021lb"
  }, _ref66), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 802.65,
    y: -358.73468,
    pointerEvents: "visible",
    id: "apr2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 826.751968,308.268706493407 26.884584,7.522493142703752",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "may2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 829.283401,93.634162 h 24.2231 v 44.58192199999999 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "may2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 841.1412409999997,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "may2021l"
  }, _ref67), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 841.1412409999997,
    y: -143.216084,
    transform: "scale(1,-1)",
    id: "may2021lb"
  }, _ref68), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 829.6,
    y: -358.73468,
    pointerEvents: "visible",
    id: "may2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 853.6365519999999,315.55088765768943 26.884584,7.527964046807537",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "jun2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 856.193401,93.634162 h 24.2231 v 43.23095466666666 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "jun2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 868.0824539999998,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "jun2021l"
  }, _ref69), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 868.0824539999998,
    y: -141.86511666666667,
    transform: "scale(1,-1)",
    id: "jun2021lb"
  }, _ref70), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 856.55,
    y: -358.73468,
    pointerEvents: "visible",
    id: "jun2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 880.521136,322.84542646273553 26.884584,6.523216095435194",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "jul2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 883.103401,93.634162 h 24.2231 v 36.476118 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "jul2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 895.0236669999997,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "jul2021l"
  }, _ref71), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 895.0236669999997,
    y: -135.11028,
    transform: "scale(1,-1)",
    id: "jul2021lb"
  }, _ref72), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 883.5,
    y: -358.73468,
    pointerEvents: "visible",
    id: "jul2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 907.40572,329.19714612722936 26.884584,1.4583011982239562",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "aug2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 910.013401,93.634162 h 24.2231 v 8.105804 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "aug2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 921.9648799999998,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "aug2021l"
  }, _ref73), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 921.9648799999998,
    y: -106.73996600000001,
    transform: "scale(1,-1)",
    id: "aug2021lb"
  }, _ref74), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 910.4499999999999,
    y: -358.73468,
    pointerEvents: "visible",
    id: "aug2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 934.290304,330.6467497039927 26.884584,10.373625573566112",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "sept2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 936.923401,93.634162 h 24.2231 v 55.389660666666664 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "sept2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 948.9060929999997,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "sept2021l"
  }, _ref75), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 948.9060929999997,
    y: -154.02382266666666,
    transform: "scale(1,-1)",
    id: "sept2021lb"
  }, _ref76), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 937.4,
    y: -358.73468,
    pointerEvents: "visible",
    id: "sept2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 961.174888,340.6118078918564 26.884584,7.818171468858363",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "oct2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 963.833401,93.634162 h 24.2231 v 40.529019999999996 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "oct2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 975.8473059999997,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "oct2021l"
  }, _ref77), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 975.8473059999997,
    y: -139.163182,
    transform: "scale(1,-1)",
    id: "oct2021lb"
  }, _ref78), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 964.35,
    y: -358.73468,
    pointerEvents: "visible",
    id: "oct2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 988.059472,348.2022656286121 26.884584,13.395394389026293",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "nov2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 990.7434010000001,93.634162 h 24.2231 v 66.19739933333334 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "nov2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 1002.7885189999997,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "nov2021l"
  }, _ref79), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 1002.7885189999997,
    y: -164.83156133333335,
    transform: "scale(1,-1)",
    id: "nov2021lb"
  }, _ref80), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 991.3,
    y: -358.73468,
    pointerEvents: "visible",
    id: "nov2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1014.944056,360.9719456944141 26.884584,8.157795182917011",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "dec2021m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1017.653401,93.634162 h 24.2231 v 39.17805266666666 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "dec2021r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 1029.7297319999996,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "dec2021l"
  }, _ref81), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 1029.7297319999996,
    y: -137.81221466666665,
    transform: "scale(1,-1)",
    id: "dec2021lb"
  }, _ref82), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 1018.25,
    y: -358.73468,
    pointerEvents: "visible",
    id: "dec2021cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1041.82864,368.8998321695521 26.884584,4.57286615494824",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "jan2022m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1044.5634009999999,93.634162 h 24.2231 v 21.61547733333333 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "jan2022r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 1056.6709449999996,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "jan2022l"
  }, _ref83), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 1056.6709449999996,
    y: -120.24963933333333,
    transform: "scale(1,-1)",
    id: "jan2022lb"
  }, _ref84), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 1045.1999999999998,
    y: -358.73468,
    pointerEvents: "visible",
    id: "jan2022cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1068.713224,373.40068468426495 26.884584,15.004717070923911",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "feb2022m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1071.473401,93.634162 h 24.2231 v 67.54836666666665 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "feb2022r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 1083.6121579999997,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "feb2022l"
  }, _ref85), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 1083.6121579999997,
    y: -166.18252866666666,
    transform: "scale(1,-1)",
    id: "feb2022lb"
  }, _ref86), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 1072.15,
    y: -358.73468,
    pointerEvents: "visible",
    id: "feb2022cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1095.597808,387.6908914184782 26.884584,2.4199607691986085",
    style: {
      fill: "none",
      stroke: "#f7a81a",
      strokeWidth: 2.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "mar2022m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1098.383401,93.634162 h 24.2231 v 10.807738666666665 h -24.2231 z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30731
    },
    id: "mar2022r"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      opacity: 0.25,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 1110.5533709999995,
    y: -79.827995,
    transform: "scale(1,-1)",
    id: "mar2022l"
  }, _ref87), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 12,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75,
      opacity: 0
    },
    x: 1110.5533709999995,
    y: -109.44190066666667,
    transform: "scale(1,-1)",
    id: "mar2022lb"
  }, _ref88), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0.5,
      stroke: "none",
      strokeWidth: 2.17585,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 26.95,
    height: 354.41916,
    x: 1099.1,
    y: -358.73468,
    pointerEvents: "visible",
    id: "mar2022cl",
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.983616,187.59655 26.884584,5.35149 26.88459,1.89052 26.89406,3.69102 26.88459,-1.57043 26.8846,1.42039 26.89406,3.92109 26.88459,-3.33092 26.8846,3.19088 h 26.89406 l 26.88459,4.72132 26.8846,2.74075 26.89407,3.81106 26.88458,0.14004 26.88458,-22.27618 26.89409,4.13114 26.88458,5.86163 26.88458,6.86191 26.88458,3.91108 26.89409,6.8419 26.88458,-0.77021 26.88458,1.93053 26.89409,4.73132 26.88458,5.32147 26.88458,2.65074 26.88458,-1.01 26.88458,2.76 26.88458,4.38 26.88458,5.34 26.88458,0.1 26.88458,2.23 26.88458,2.38 26.88458,3.04 26.88458,-4.65 26.88458,7.01 26.88458,-0.69 26.88458,4.8 26.88458,-5 26.88458,-3 26.88458,3.5",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.125,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "4.5, 2.25",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "passive"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      lineHeight: 1.25,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.75
    },
    x: 795.88745,
    y: -238.29311,
    transform: "scale(1,-1)",
    id: "text1128"
  }, _ref89), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0,1,1,0,0,0)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 14,
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      writingMode: "lr-tb",
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    x: 73.334663,
    y: 1155.06995,
    id: "text881"
  }, _ref90), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ebebeb",
      strokeWidth: "0.75px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 61.1,92.990001 H 1036.05345",
    id: "xline"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfRu);
export default __webpack_public_path__ + "static/media/perf_ru.3aa3bbd4.svg";
export { ForwardRef as ReactComponent };